import React, { useState } from "react";
import queryString from "query-string";
import { Form, Progress, Alert, Input } from "reactstrap";

import { useLocalization } from "../../containers/I18nProvider";
import { WithCaptcha } from '../../containers/captcha';

const LoginForm = ({ api, location, TurnstileComponent, ...props }) => {
  const { translate } = useLocalization();
  const [onLogin, setOnLogin] = useState(false);
  const [error, setError] = useState({ open: false, message: "" });
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [message, setMessage] = useState("")

  const parameters = queryString.parse(location.search);
  parameters.idp = 'uslink';

  const onSubmit = async (ev) => {
    ev.preventDefault();
    setOnLogin(true)
    setError({ open: false, message: "" })


    api.userPassLogin({ username, password },
      parameters
    )
      .then((response) => {
        setOnLogin(false)
        window.location = parameters.redirect_uri + "?" + queryString.stringify(response);
      })
      .catch((error) => {
        const _translate = translate(error.errorCode);

        if (_translate) {
          setMessage(_translate);
        } else if (error.details) {
          setMessage(error.details);
        }
        setOnLogin(false)
        setError({ open: true, message: message })
      });
  }

  return (
    <>
      <Form onSubmit={(event) => onSubmit(event)} className="uslink-login">
        <div className="uslink-wrapper">
          <div className="uslink-form-group">
            <div className="uslink-form-content">
              <div>
                <img src="https://sp-logos.tbxnet.com/uslink.png" alt="ReeluNet" />
              </div>
              <div className="uslink-form-container uslink-form-container-login">
                <Input
                  className="uslink-input"
                  disabled={onLogin}
                  placeholder={translate("PlaceholderUserName")}
                  required={true}
                  tabIndex={1}
                  type="text"
                  autoCorrect="off"
                  autoCapitalize="none"
                  name="login"
                  id="login"
                  onChange={e => setUsername(e.target.value)}
                />
              </div>
              <div className="uslink-form-container">
                <Input
                  className="uslink-input"
                  required={true}
                  disabled={onLogin}
                  placeholder={translate("PlaceholderPassword")}
                  tabIndex={1}
                  type="password"
                  autoCorrect="off"
                  autoCapitalize="none"
                  id="password"
                  name="login"
                  onChange={e => setPassword(e.target.value)}
                />
              </div>
              <div className="uslink-button">
                {!onLogin ? (
                  <button type="submit">
                    <span className="uslink-enter-text">
                      {translate("ButtonEnter")}
                    </span>
                  </button>
                ) : (
                  <Progress animated color="danger" value={100} />
                )}
              </div>
              <TurnstileComponent setTurnstileSuccess={props.setTurnstileSuccess} />
              <div className="messages-container">
                <Alert
                  color="danger"
                  id="error-message"
                  isOpen={error.open}
                  toggle={() => setError({ open: false })}
                >
                  {error.message}
                </Alert>
              </div>
            </div>
          </div>
        </div>
      </Form>
    </>
  );
}

export default WithCaptcha(LoginForm, { useInsideForm: true, style: { marginTop: '2rem' } });
